import { Icons } from "@/types/icons";
import type { BuildContactItemsOptions, VcardContactItem } from "./types";
import { generateVCard } from "@/utils/downloadHelper";
import { VcardData } from "@/types/qr";
import { logError } from "@/services/DatadogService";

export const buildContactItems = ({
  data,
  translations,
  addressData,
  isInitialPreview,
}: BuildContactItemsOptions): VcardContactItem[] => {
  if (!data) return [];

  const { address, fullAddress, addressMapsURL } = addressData;

  const fields = [
    {
      id: "email",
      icon: Icons.email,
      title: translations?.preview_email,
      subtitle: data?.email,
      link: data?.email ? `mailto:${data.email}` : undefined,
      isUncheckValidURL: true,
    },
    {
      id: "mobile",
      icon: Icons.mobilePhone,
      title: translations?.preview_phone,
      subtitle: data?.mobilePhone && data?.mobilePhone,
      link: data?.mobilePhone ? `tel:${data?.mobilePhone}` : undefined,
      isUncheckValidURL: true,
    },
    {
      id: "landline",
      icon: Icons.landlinePhone,
      title: translations?.preview_phone_alt,
      subtitle: data?.landlinePhone,
      link: data?.landlinePhone ? `tel:${data?.landlinePhone}` : undefined,
      isUncheckValidURL: true,
    },
    {
      id: "fax",
      icon: Icons.fax,
      title: translations?.preview_fax_phone,
      subtitle: data?.fax,
      link: data?.fax ? `fax:${data?.fax}` : undefined,
      isUncheckValidURL: true,
    },
    {
      id: "address",
      icon: Icons.location,
      subtitle: fullAddress,
      link: addressMapsURL,
      hasCondition: !!address,
    },
    {
      id: "website",
      icon: Icons.website,
      title: translations?.preview_website,
      subtitle: data?.website,
      link: data?.website,
      isUncheckValidURL: true,
    },
    {
      id: "company",
      icon: Icons.building,
      title: translations?.preview_company,
      subtitle: data?.companyName,
    },
    {
      id: "profession",
      icon: Icons.profession,
      title: translations?.preview_profession,
      subtitle: data?.profession,
      hasCondition: !isInitialPreview && !!data?.profession,
    },
  ];

  return fields.filter((field) => field.hasCondition !== false && !!field.subtitle);
};

export const handleDownloadVCard = async (vcardFileData: VcardData) => {
  try {
    await generateVCard(vcardFileData);
  } catch (error) {
    logError(error instanceof Error ? error : new Error(String(error)), {
      component: "VcardTemplate",
      action: "handleDownloadVCard",
    });
  }
};
